import React from 'react';

const Badge = ({ className, label }) => <div className={`inf-badge ${className}`}>{label}</div>;

export default Badge;
